// extracted by mini-css-extract-plugin
module.exports = {"component":"FixieCard_component___7_2J","fixieImage":"FixieCard_fixieImage__Re8YW"};